import { render } from "./EquipCar.vue?vue&type=template&id=0066364c"
import script from "./EquipCar.vue?vue&type=script&lang=js"
export * from "./EquipCar.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./EquipCar.vue?vue&type=style&index=0&id=0066364c&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script